/** @jsxImportSource @emotion/react */
import { SerializedStyles } from "@emotion/react";
import { MaxDaysAccessRuleRow } from "./MaxDaysAccessRuleRow";
import { EditableMaxDaysAccessRule } from "./maxDays";

type Props = {
  resources: Record<string, any>;
  rules?: EditableMaxDaysAccessRule[];
  onChange: (rules: EditableMaxDaysAccessRule[]) => void;
  rootCss?: SerializedStyles;
};

/**
 * Currently only one MaxDaysAccessRule is permitted.
 * In the case where there are multiple max days rules, 
 * the extra rules will be deleted during Save 
 * in the parent component.
 */
export function MaxDaysAccessRuleEditor({
  resources,
  rules = [],
  onChange,
  rootCss,
}: Props) {
  const firstRule = rules[0];

  const handleFirstRuleChange = (
    updatedRule: EditableMaxDaysAccessRule | undefined,
  ) => {
    if (!updatedRule) {
      onChange([]);
      return;
    }

    onChange([
      updatedRule,
      ...rules.slice(1),
    ]);
  };

  return (
    <div css={rootCss}>
      <MaxDaysAccessRuleRow
        resources={resources}
        rule={firstRule}
        onChange={handleFirstRuleChange}
      />
    </div>
  );
}
